export const ProjectEditDialogTitle = {
  add: '案件新規登録',
  update: '案件情報編集',
};
